import { render, staticRenderFns } from "./compSKP.vue?vue&type=template&id=62716c10&"
import script from "./compSKP.vue?vue&type=script&lang=js&"
export * from "./compSKP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports